import React from 'react';
import { Route } from 'react-router-dom';
import LibraryPage from './LibraryPage';

export const libraryRoutes = (
  <Route path="library" element={<LibraryPage />} />
);
